import web from "../web";

class AdminService {
    index(token){
        return web.get("/api/pays", { headers: { 'Authorization': 'Bearer '+token } })
    }

   
}

export default new AdminService()